/* ======================================================
   AFINA variant PDP — gallery, finishes, plan cards, qty,
   add-to-cart (cart-drawer aware). Used by afina-pdp-* pages.
   ====================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.afina-vpdp');
  if (!root) return;
  var DATA = {};
  try { DATA = JSON.parse(root.querySelector('[data-afina-product-data]').textContent); } catch (e) { DATA = { variants: [] }; }
  var FINISHES = DATA.finishes || [];
  var MONEY = DATA.moneyFormat || '${{amount}}';
  function finishByColor(c) { return FINISHES.filter(function (f) { return f.color === c; })[0]; }
  function activeOf(f) { if (!f) return null; return state.plan === 'sub' ? f.sub : f.once; }

  /* Mirrors Liquid's `money_without_trailing_zeros` for the ACTIVE MARKET's format.
     Each money_format token implies its own separators — NL/DE use
     "€{{amount_with_comma_separator}}" (1.234,56), so substituting one dot-formatted
     string into every token renders the wrong decimal mark outside the US. */
  function money(cents) {
    cents = parseInt(cents, 10) || 0;
    var neg = cents < 0; if (neg) cents = -cents;
    function group(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function fmt(withDecimals, thousands, decimal) {
      if (!withDecimals) return group(String(Math.round(cents / 100)), thousands);
      if (cents % 100 === 0) return group(String(cents / 100), thousands);   /* no trailing zeros */
      var p = (cents / 100).toFixed(2).split('.');
      return group(p[0], thousands) + decimal + p[1];
    }
    var out = MONEY
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, fmt(false, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, fmt(false, ' ', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,            fmt(true,  '.', ','))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,            fmt(true,  ' ', ','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,       fmt(true,  "'", '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,                     fmt(false, ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g,                                 fmt(true,  ',', '.'));
    return neg ? '-' + out : out;
  }

  var vidEl0 = document.querySelector('.afina-vpdp [data-afina-vid]');
  var initId = vidEl0 ? parseInt(vidEl0.value, 10) : null;
  var first = (initId && FINISHES.filter(function (f) { return (f.sub && f.sub.id === initId) || (f.once && f.once.id === initId); })[0])
    || FINISHES.filter(function (f) { return (f.sub && f.sub.available) || (f.once && f.once.available); })[0] || FINISHES[0] || {};
  var state = { color: first.color, plan: (first.sub && first.sub.plan) ? 'sub' : 'once', qty: 1 };
  var $ = function (s) { return root.querySelector(s); };
  var atcForm = root.querySelector('[data-afina-atc]');
  var discAmt = atcForm ? (parseInt(atcForm.getAttribute('data-afina-discount-amount') || '0', 10) || 0) : 0;
  /* Percentage promo (data-afina-discount-pct): display-only, SUBSCRIPTION price only.
     The coupon itself still applies to the whole cart on add-to-cart either way.
     Uses floor to match Liquid's integer `times/divided_by` so server and client agree. */
  var discPct = atcForm ? (parseFloat(atcForm.getAttribute('data-afina-discount-pct') || '0') || 0) : 0;
  function sale(cents) { var c = parseInt(cents, 10) || 0;
    /* Round UP to the next whole dollar, matching Liquid's
       `times: keep | divided_by: 10000.0 | ceil | times: 100`. */
    return discPct > 0 ? Math.ceil(c * (100 - discPct) / 10000) * 100 : c; }

  function render() {
    var f = finishByColor(state.color); if (!f) return;
    var act = activeOf(f) || {};
    var vid = $('[data-afina-vid]'); if (vid) vid.value = act.id || '';
    var sp = $('[data-afina-sp]');
    if (sp) { if (state.plan === 'sub' && f.sub && f.sub.plan) { sp.value = f.sub.plan; sp.disabled = false; } else { sp.value = ''; sp.disabled = true; } }
    var fn = $('[data-afina-finish-name]'); if (fn && f.color) fn.textContent = f.color;
    var onceP = $('[data-afina-plan-price="once"]'); if (onceP && f.once) onceP.innerHTML = money(f.once.price);
    var subP = $('[data-afina-plan-price="sub"]'); if (subP && f.sub) subP.innerHTML = money(discAmt ? Math.max(0, f.sub.price - discAmt) : sale(f.sub.price));
    /* Struck pre-sale price, subscription only — one-time is never discounted for display. */
    var subW = $('[data-afina-plan-was="sub"]'); if (subW && f.sub) subW.innerHTML = money(f.sub.price);
    var q = $('[data-afina-qty]'); if (q) q.textContent = state.qty;
    var qi = $('[data-afina-qty-input]'); if (qi) qi.value = state.qty;
    var add = $('[data-afina-add]'), lbl = $('[data-afina-add-label]');
    var avail = !!act.available;
    var cta = (add && add.getAttribute('data-afina-cta')) || 'Add to Cart';
    if (add) add.disabled = !avail;
    if (lbl) lbl.textContent = avail ? cta : 'Sold out';
    root.querySelectorAll('[data-afina-swatch]').forEach(function (b) { var on = b.getAttribute('data-afina-swatch') === state.color; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    root.querySelectorAll('[data-afina-plan]').forEach(function (b) { var on = b.getAttribute('data-afina-plan') === state.plan; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    root.querySelectorAll('[data-afina-gift-sub]').forEach(function (g) { g.setAttribute('data-locked', state.plan === 'sub' ? 'false' : 'true'); });
  }

  /* Jump the gallery to the variant's own image (variant.featured_media, set in Admin). */
  var showSlide = function () {};
  function showFinishMedia() { var f = finishByColor(state.color); if (f && f.media != null) showSlide(f.media); }
  root.querySelectorAll('[data-afina-swatch]').forEach(function (b) {
    b.addEventListener('click', function () { var c = b.getAttribute('data-afina-swatch'); if (finishByColor(c)) { state.color = c; render(); showFinishMedia(); } });
  });
  root.querySelectorAll('[data-afina-plan]').forEach(function (b) { b.addEventListener('click', function () { state.plan = b.getAttribute('data-afina-plan'); render(); }); });
  var qm = $('[data-afina-qminus]'), qp = $('[data-afina-qplus]');
  if (qm) qm.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); render(); });
  if (qp) qp.addEventListener('click', function () { state.qty += 1; render(); });

  /* Accordions are handled globally by afina-home.js ([data-afina-acc] + [data-afina-acc-icon]). */

  (function () {
    var slides = root.querySelectorAll('[data-afina-slide]'); if (!slides.length) return;
    var dots = root.querySelectorAll('[data-afina-dot]'), thumbs = root.querySelectorAll('[data-afina-thumb]'), idx = 0;
    function show(n) { idx = (n + slides.length) % slides.length; slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); }); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); }); thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); }); }
    var p = $('[data-afina-gprev]'), n = $('[data-afina-gnext]');
    if (p) p.addEventListener('click', function () { show(idx - 1); });
    if (n) n.addEventListener('click', function () { show(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    showSlide = show;
  })();

  var form = $('[data-afina-atc]');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = finishByColor(state.color); var act = activeOf(f) || {};
    if (!act.id || !act.available) return;
    var item = { id: act.id, quantity: state.qty };
    if (state.plan === 'sub' && f.sub && f.sub.plan) item.selling_plan = f.sub.plan;
    var items = [item];
    /* Subscription-only gifts, opted into per page via data-afina-gift-variants
       (a comma-separated variant id list). One of each per order, regardless of
       quantity, and never on a one-time purchase — which is what the locked/unlocked
       [data-afina-gift-sub] cards already promise the shopper.
       These gift products are NOT $0: an automatic discount has to zero them. */
    var giftIds = [];
    if (state.plan === 'sub') {
      (form.getAttribute('data-afina-gift-variants') || '').split(',').forEach(function (gid) {
        gid = parseInt(gid, 10);
        if (gid) giftIds.push(gid);
      });
    }
    giftIds.forEach(function (gid) { items.push({ id: gid, quantity: 1 }); });

    /* Gifts must never accumulate past one.
       Two things fight us: /cart/add.js increments, and a cart app rewrites line
       properties AFTER an add completes, which re-keys the lines. So reading the cart
       BEFORE adding can hand back keys that are already stale by the time the update
       posts — the update silently misses and Shopify appends a second gift line.
       Instead: add first, then normalise, re-reading the cart each pass and retrying
       until every gift variant totals exactly 1. Converges in one pass normally.
       The product itself is never touched — asking for two showerheads gives two. */
    function normalizeGifts(tries) {
      if (!giftIds.length) return Promise.resolve();
      if (tries <= 0) return Promise.resolve();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {}, kept = {};
          (cart.items || []).forEach(function (li) {
            if (giftIds.indexOf(li.id) === -1) return;
            if (!kept[li.id]) { kept[li.id] = true; if (li.quantity !== 1) updates[li.key] = 1; }
            else { updates[li.key] = 0; }                    /* extra line for the same gift */
          });
          if (!Object.keys(updates).length) return null;      /* already exactly one of each */
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates }) })
            .then(function () { return normalizeGifts(tries - 1); });   /* verify it stuck */
        })
        .catch(function () { /* never block the add */ });
    }

    var add = $('[data-afina-add]'), lbl = $('[data-afina-add-label]'), orig = lbl ? lbl.textContent : '';
    if (add) add.disabled = true; if (lbl) lbl.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (resp) { return normalizeGifts(3).then(function () { return resp; }); })
      .then(function (resp) {
        /* Paint the drawer from a sections object (from /cart/add.js or a fresh render). */
        function paint(sections) {
          /* Landers can opt out of the drawer and send the buyer straight to checkout
             (data-afina-after-add="checkout"). Runs after any discount is applied. */
          if (form.getAttribute('data-afina-after-add') === 'checkout') { window.location.href = '/checkout'; return; }
          if (sections && sections['cart-icon-bubble']) { var b = document.getElementById('cart-icon-bubble'); if (b) b.innerHTML = sections['cart-icon-bubble']; }
          if (add) add.disabled = false; if (lbl) lbl.textContent = orig;
          var drawer = document.querySelector('cart-drawer');
          if (!drawer) { window.location.href = '/cart'; return; }
          try {
            var html = sections && sections['cart-drawer'];
            if (html) { var tmp = document.createElement('div'); tmp.innerHTML = html; var fi = tmp.querySelector('#CartDrawer'), ci = drawer.querySelector('#CartDrawer'); if (fi && ci) ci.innerHTML = fi.innerHTML; }
          } catch (e) {}
          drawer.classList.remove('is-empty');
          var didOpen = false;
          if (typeof drawer.open === 'function') { try { drawer.open(); didOpen = true; } catch (e) {} }
          if (!didOpen) { drawer.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
        }
        /* Optional auto-apply discount (per-PDP via data-afina-discount): apply the code,
           then re-render the drawer so it reflects both the new item and the discount. */
        var dc = form.getAttribute('data-afina-discount');
        if (dc) {
          fetch('/discount/' + encodeURIComponent(dc), { redirect: 'manual' })
            .catch(function () {})
            .then(function () { return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
            .then(function (fresh) { paint(fresh || resp.sections); })
            .catch(function () { paint(resp.sections); });
        } else {
          paint(resp.sections);
        }
      })
      .catch(function () { window.location.href = '/cart'; });
  });

  render();
  showFinishMedia();
})();
